import { h } from 'preact';
import './ProductTile.scss';
import { productType } from '../propTypes';
import * as cartActions from '../actions/cart';
import CurrencyFormat from './ui/CurrencyFormat';

export default function ProductTile(props) {
  const { product } = props;
  const firstSku = product.skus && product.skus.data.length > 0 ? product.skus.data[0] : false;
  const productMainImage = firstSku ? firstSku.image : product.images[0] || 'https://picsum.photos/300/200/?random';
  const hasPrice = !!product.price;
  const productPrice = firstSku ? { amount: firstSku.price/100, currency: firstSku.currency } : product.price;
  const productSkuId = product.skus && product.skus.data.length > 0 ? product.skus.data[0].id : null;
  const qty = 1;

  return (
    <div className="_ic _ic__productTile" data-component="ProductTile">
      <span className="_ic__productTile-header">{product.name}</span>
      <div className="_ic__productTile-image" style={{ backgroundImage: 'url(' + productMainImage + ')'}} />
      {product.description && <div className="_ic__productTile-desc">{product.description}</div>}
      <div className="_ic__productTile-meta">
        <strong className="_ic__price">{hasPrice ? <CurrencyFormat {...productPrice} /> : 'n/a'}</strong>
        <a className="_ic__btn _ic__btn-addToCart" onClick={() => addToCart(product, productSkuId, qty)}>Add to Cart</a>
      </div>
    </div>
  );
}

ProductTile.propTypes = {
  product: productType.isRequired,
};

function addToCart(product, skuId, qty) {
  cartActions.addProduct(product, skuId, qty);
}
